module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-BV.ded2f6ee.png";